import React, { useState, useMemo } from "react";
import { Row, Col } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import TextInput from "../../../custom/components/Text-Input/TextInput.js";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput.js";
import CustomForm from "../../../custom/Forms/CustomForm.js";
import { saveRecords } from "../../../services/api.service.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useCreateForm from "../../../custom/Utils/UseCreateFormUtils.js";
import { createPageData } from "./CategoryFile.js";
import { basicFormData } from "./CategoryFile.js";
import { validate } from "../../../custom/validations/Validate.js";

const CategoryCreate = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  } = createPageData();
  const [loadingData, setLoadingData] = useState(false);
  const initialPayload = useMemo(() => payload, []);

  const { formData, onInputChange, formErrors, setFormErrors } = useCreateForm(
    getEndpoint,
    id,
    initialPayload,
    basicFormData(),
    validationType
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingData(true);

    try {
      const validationErrors = validate(validationType, formData.inputData);
      if (Object.keys(validationErrors).length > 0) {
        setLoadingData(false);
        setFormErrors(validationErrors);
        return;
      }

      const isCreating = !id;
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));

      const payload = {
        id,
        modelName: initialPayload?.modelName,
        inputData: {
          ...formData.inputData,
          created_by: isCreating
            ? userDetails.id
            : formData.inputData.created_by,
          updated_by: userDetails.id,
        },
      };

      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      if (responseData && responseData.code == 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData?.message ||
            `Error while ${id ? "updating" : "saving"} ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        <Col md="6" className="mt-3">
          <TextInput
            label="Category"
            name="category_name"
            value={formData.inputData.category_name}
            onChange={onInputChange}
            placeholder="Category name"
            inputClassName="form-control "
            labelClassName="form-label"
            autocomplete={"off"}
            customError={formErrors.category_name}
            asterisk={true}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col lg="12">
          <CheckboxInput
            label="Is Active"
            name="is_active"
            value={formData.inputData.is_active}
            checked={formData.inputData.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
            disabled={false}
            required={false}
            customError={formErrors.is_active}
          />
        </Col>
      </Row>
    </CustomForm>
  );
};
export default CategoryCreate;
